import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getRubroHabilitado } from "../../http/actions/RubroAction";
import CheckboxGroup from "../../data/CheckBox";

const AgregarRelacionClienteRubroModal = ({ open, onClose, onSubmit, cliente }) => {
  const [rubros, setRubros] = useState([]);
  const [selectedRubros, setSelectedRubros] = useState([]);

  useEffect(() => {
    if (open && cliente) {
      fetchRubros();
      // Inicializar los checkboxes con los rubros ya asociados al cliente
      if (cliente.idRubro && cliente.idRubro.length > 0) {
        setSelectedRubros(cliente.idRubro);
      } else {
        setSelectedRubros([]);
      }
    }
  }, [open, cliente]);

  const fetchRubros = () => {
    getRubroHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setRubros(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSelectedRubros(prev => 
      checked 
        ? [...prev, id]
        : prev.filter(item => item !== id)
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      idCliente: cliente.id,
      idRubro: selectedRubros
    });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox sx={{ width: '90%', maxWidth: 800, maxHeight: '90vh', overflow: 'auto' }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant='h6' sx={{ mb: 3 }}>
          Gestionar Rubros
        </Typography>
        
        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 1 }}>
          Cliente: {cliente?.nombre}
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 3 }}>
          Seleccione los rubros asociados a este cliente.
        </Typography>
        
        <form onSubmit={handleSubmit}>
          {/* Rubros */}
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Rubros Disponibles</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <CheckboxGroup
                  title="Rubros"
                  items={rubros}
                  selectedItems={selectedRubros}
                  onChange={handleCheckboxChange}
                  name="rubros"
                />
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary"
            >
              Guardar cambios
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default AgregarRelacionClienteRubroModal;